import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class ErrorNoticeService {

  sound = new Audio();
  playing: boolean = false;
  errorSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  Error(): Observable<boolean> {
    return this.errorSubject.asObservable();
  }

  constructor() {
    this.sound.src = "../assets/sounds/bleep.mp3";
    this.sound.load();
  }

  public PlayError() {
    if (!this.playing) {
      this.errorSubject.next(true);
      this.playing = true;
      setTimeout(() => {
        try {
          // this.sound.play();
        } catch (error) {
          console.log("User gesture required to play sound.");
        }
      }, 700);
      setTimeout(() => {
        this.errorSubject.next(false);
      }, 2000);
      this.playing = false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/services/error-notice.service.ts